var Iframe_default = {
  "iframe": "IkAyi"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
